'use client';

import { useTranslation } from 'next-i18next';
import {
  AnimatedCollapsible, Button, SanitizeHTML,
} from '@components/common';
import { commonStyles } from '../common-styles';

// Interface
// ************************************
export interface EmployerDescriptionProps {
  description: string;
}

/**
 * @description Employer Description component.
 * Displays a collapsible section with the employer's description.
 *
 * - **description** -string. The employer's description, potentially containing HTML from a WYSIWYG editor.
 */
export const EmployerDescription = (props: EmployerDescriptionProps) => {
  // Destructure props
  const { description } = props;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *****************************************
  return (
    <div>
      <AnimatedCollapsible
        renderContent={
          () => (
            <SanitizeHTML
              as="div"
              htmlContent={description}
              config={{ ADD_TAGS: ['iframe'] }}
              className="prose"
            />
          )
        }
        renderToggle={(isExpanded, handleToggle) => (
          <>
            {!isExpanded && (
              <div className={commonStyles.readMoreGradient} />
            )}
            <div className="mt-1 flex justify-center">
              <Button size="sm" color="white" rounding="full" onClick={handleToggle} className={commonStyles.showMoreButton}>
                {isExpanded ? t('global.label.see_less') : t('global.label.see_more')}
              </Button>
            </div>
          </>
        )}
        collapsedHeight={8 * 24}
      />
    </div>
  );
};
